import { jsx as y, jsxs as F, Fragment as V } from "@emotion/react/jsx-runtime";
import { ApiError as x } from "@inflearn/datasource-rest";
import { useShowNotification as k } from "@inflearn/ds-react";
import { u as K, aC as W, a as j, e as U, q as N, S as B } from "./StickyHeaderSkeleton-dac046bb.mjs";
import { b as Z, u as L, c as J, d as A, W as X, e as tt, p as et, Q as ot, z as rt, D as nt, g as I, x as O, A as v, R as it } from "./Header-dd25ab18.mjs";
import { useDisclosure as st } from "@mantine/hooks";
import { useQueryClient as at } from "@tanstack/react-query";
import { useEffect as ut } from "react";
import { u as ct } from "./useCourseCategoryQuery-d2c4031c.mjs";
import { u as lt } from "./useMyCourseCategoryQuery-7b6487e0.mjs";
import "@emotion/react";
import "@mantine/core";
import "react/jsx-runtime";
import "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/updateLocale";
import "@inflearn/analytics";
import "./LoginModal-b933021f.mjs";
import "@inflearn/ds-modal";
import "react-hook-form";
import "dayjs/plugin/duration";
import "dayjs/plugin/relativeTime";
import "react-error-boundary";
function gt(t, o) {
  return Z(t, o);
}
const Y = {
  arrayFormat: "comma",
  skipNull: !0,
  skipEmptyString: !0
};
function pt(t) {
  return t.map((o) => o.slug);
}
function Ct(t) {
  return t.map((o) => o.slug);
}
function mt(t, o) {
  const r = t.length, e = o.length, i = r === 1 && e <= 1, s = r > 0 || e > 0;
  if (i) {
    const c = t[0].slug, C = e === 1 ? `/${o[0].slug}` : "";
    return {
      pathname: `/courses${c ? `/${c}` : ""}${C}`,
      categories: [],
      subCategories: []
    };
  }
  return s ? {
    pathname: "/courses",
    categories: pt(t),
    subCategories: Ct(o)
  } : {
    pathname: "/courses",
    categories: [],
    subCategories: []
  };
}
function dt(t, o) {
  const r = mt(t, o), e = {};
  return r.categories.length > 0 && (e.categories = r.categories), r.subCategories.length > 0 && (e.subCategories = r.subCategories), {
    pathname: r.pathname,
    query: e
  };
}
function E(t) {
  return Array.isArray(t) ? t : t ? [t] : [];
}
function w(t, o) {
  if (t.length !== o.length)
    return !1;
  const r = [...t].sort(), e = [...o].sort();
  return r.every((i, s) => i === e[s]);
}
function yt(t, o, r, e) {
  const i = dt(r, e), s = t !== i.pathname, c = E(o.categories), C = E(o.subCategories), m = E(i.query.categories), f = E(i.query.subCategories), _ = !w(c, m) || !w(C, f);
  return !s && !_ ? {
    type: "NO_CHANGE"
  } : s ? {
    type: "PATH_CHANGE",
    navigationConfig: i
  } : {
    type: "QUERY_ONLY",
    navigationConfig: i
  };
}
function xt() {
  const {
    data: t
  } = L();
  return t != null && t.id ? /* @__PURE__ */ y(ft, {}) : null;
}
function ft() {
  const {
    t
  } = K(), {
    lang: o
  } = W(), {
    trackEvent: r
  } = j(), [e, i] = J("MY_CATEGORY"), s = A({
    enabled: e,
    valueKey: I.IS_FIRSTREGISTER,
    onSuccessPipe: (n) => (n.delete(O.TO), n)
  }), c = A({
    enabled: e,
    valueKey: I.COURSE_LIST,
    onSuccessPipe: (n) => (n.delete(O.TO), n)
  }), C = A({
    enabled: e,
    valueKey: I.ACCOUNT,
    onSuccessPipe: (n) => (n.delete(O.TO), n)
  }), m = c ? "course_list" : C ? "account" : null, f = at(), [_, q] = st(!1), {
    showNotification: R
  } = k(), {
    data: S
  } = L(), {
    data: d
  } = ct(), {
    data: a
  } = lt(), {
    setCache: G
  } = X(S == null ? void 0 : S.id), {
    mutate: P,
    isLoading: Q
  } = tt({
    url: v.CLIENT_V1_MY_CATEGORY
  });
  ut(() => {
    if (!(e && a))
      return;
    const n = a.map((l) => ht(l) ? `${l.parent.title} > ${l.title}` : t("{{category.title}} > 전체", {
      "category.title": l.title
    }));
    r(U.VIEW_MYCATEGORY, {
      is_firstregister: s,
      mycategory: n,
      mycategory_spot: m
    });
  }, [e, a]);
  const b = () => {
    i.close(), G();
  }, D = (n) => {
    const l = a == null ? void 0 : a.map((u) => u.id), z = n.map((u) => u.id);
    if (gt(l, n)) {
      b();
      return;
    }
    P({
      categoryIds: z
    }, {
      onSuccess: () => {
        b();
        const u = n.map((g) => {
          var h;
          return g.type === "PARENT" ? t("{{category.title}} > 전체", {
            "category.title": g.title
          }) : `${((h = d == null ? void 0 : d.find((p) => p.children.find((T) => T.id === g.id))) == null ? void 0 : h.title) || ""} > ${g.title}`;
        });
        if (r(U.CLICK_SAVE_MYCATEGORY, {
          is_firstregister: s,
          mycategory: u,
          mycategory_spot: m
        }), s) {
          const {
            mainCategories: g,
            subCategories: M
          } = Et(n), h = N.parse(window.location.search, {
            arrayFormat: Y.arrayFormat
          }), p = yt(window.location.pathname, h, g, M);
          if (p.type === "NO_CHANGE") {
            f.invalidateQueries([v.CLIENT_V1_MY_CATEGORY]);
            return;
          }
          if (p.navigationConfig) {
            const T = N.stringifyUrl({
              url: p.navigationConfig.pathname,
              query: p.navigationConfig.query
            }, Y);
            window.location.href = T;
            return;
          }
        }
        f.invalidateQueries([v.CLIENT_V1_MY_CATEGORY]);
      },
      onError: (u) => {
        if (!(u instanceof x)) {
          R({
            type: "error",
            title: t("처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.")
          });
          return;
        }
        if (u.statusCode === it.UNAUTHORIZED) {
          i.close(), q.open();
          return;
        }
        R({
          type: "error",
          title: t("처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.")
        });
      }
    });
  }, H = () => {
    const n = location.href;
    window.location.href = N.stringifyUrl({
      url: B.SIGN_IN,
      query: {
        referUrl: encodeURIComponent(n)
      }
    });
  }, $ = !!a && a.length !== 0;
  return /* @__PURE__ */ F(V, { children: [
    /* @__PURE__ */ y(et, { isOpened: e, lang: o, closeOnClickOutside: $, onClose: i.close, hideLaterButton: s, children: !a || !d ? /* @__PURE__ */ y(ot, {}) : /* @__PURE__ */ y(rt, { onSave: D, myCategories: a, courseCategories: d, isLoading: Q }) }),
    /* @__PURE__ */ y(nt, { lang: o, isOpened: _, handleClose: H })
  ] });
}
const ht = (t) => t.type === "CHILD";
function Et(t) {
  const o = t.filter((e) => e.type === "PARENT").map((e) => ({
    slug: e.slug,
    id: e.id,
    title: e.title
  })), r = t.filter((e) => e.type === "CHILD").map((e) => ({
    slug: e.slug,
    id: e.id,
    title: e.title
  }));
  return {
    mainCategories: o,
    subCategories: r
  };
}
export {
  xt as default
};
